/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ButtonFormat*`'s.
 */
export type ButtonFormat = ButtonFormatStrong | ButtonFormatSoft | ButtonFormatTransparent;

/**
 * The Button strong format type.
 */
export type ButtonFormatStrong = typeof BUTTON_FORMAT_STRONG;

/**
 * The Button soft format type.
 */
export type ButtonFormatSoft = typeof BUTTON_FORMAT_SOFT;

/**
 * The Button transparent format type.
 */
export type ButtonFormatTransparent = typeof BUTTON_FORMAT_TRANSPARENT;

/**
 * The Button strong format constant.
 */
export const BUTTON_FORMAT_STRONG = `strong`;

/**
 * The Button soft format constant.
 */
export const BUTTON_FORMAT_SOFT = `soft`;

/**
 * The Button transparent format constant.
 */
export const BUTTON_FORMAT_TRANSPARENT = `transparent`;
